import parseLink from './parse-link'

export default function parseParent(parent) {
  return {
    ...parent,
    link: parseLink(parent.ID, parent.objCode),
  }
}
